import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";
import type { CardEventCategory } from "../types";
import { getCardEventName, getFirstNewAssetEventName, getNewAssetEventName, getViewAllEventName } from "../utils";

type ActionArgs = {
    trackingCategory: CardEventCategory;
    totalResultsCount: number;
};

const createCardsTrackingService = (track: TrackFn) => {
    const trackClickAction = (eventCategory: CardEventCategory, eventName: string): void => {
        track(eventCategory, "click", eventName);
    };

    const trackHoverAction = (eventCategory: CardEventCategory, eventName: string): void => {
        track(eventCategory, "hover", eventName);
    };

    return {
        card: {
            trackHovered({ trackingCategory, totalResultsCount }: ActionArgs) {
                const eventName = getCardEventName(trackingCategory, totalResultsCount);

                trackHoverAction(trackingCategory, eventName);
            },
        },

        viewAllButton: {
            trackClicked({ trackingCategory }: ActionArgs) {
                const eventName = getViewAllEventName(trackingCategory);

                trackClickAction(trackingCategory, eventName);
            },
            trackHovered({ trackingCategory }: ActionArgs) {
                const eventName = getViewAllEventName(trackingCategory);

                trackHoverAction(trackingCategory, eventName);
            },
        },

        watchTutorialButton: {
            trackClicked({ trackingCategory }: ActionArgs) {
                trackClickAction(trackingCategory, "tutorial");
            },
            trackHovered({ trackingCategory }: ActionArgs) {
                trackHoverAction(trackingCategory, "tutorial");
            },
        },

        newAssetButton: {
            trackClicked({ trackingCategory, totalResultsCount }: ActionArgs) {
                const eventName = getNewAssetEventName(trackingCategory);

                trackClickAction(trackingCategory, `${eventName}/${totalResultsCount}`);
            },
            trackHovered({ trackingCategory, totalResultsCount }: ActionArgs) {
                const eventName = getNewAssetEventName(trackingCategory);

                trackHoverAction(trackingCategory, `${eventName}/${totalResultsCount}`);
            },
        },

        firstNewAssetButton: {
            trackClicked({ trackingCategory, totalResultsCount }: ActionArgs) {
                const eventName = getFirstNewAssetEventName(trackingCategory);

                trackClickAction(trackingCategory, `${eventName}/${totalResultsCount}`);
            },
            trackHovered({ trackingCategory, totalResultsCount }: ActionArgs) {
                const eventName = getFirstNewAssetEventName(trackingCategory);

                trackHoverAction(trackingCategory, `${eventName}/${totalResultsCount}`);
            },
        },
    };
};

export default createCardsTrackingService;
